<template>
  <div
    class="col-xs-12 col-sm-12 p-0"
    :class="[(alignment =='left' && !colBlock) ?'col-md-pull-6':'',
     colBlock ? '' : 'col-md-6']"
  >
    <div v-if="design_type=='desktop'" class="desc-content">
      <div class="desc-subheader text-color-blue" v-html="content.header"></div>
      <div v-html="content.description"></div>
    </div>
    <div
      v-if="design_type=='default' || design_type=='screen' "
      :class="[(content.bg_color!== undefined && content.bg_color=='white')?'':'bg-color-blue text-color-white']"
      class="row box-min-height p-35"
    >
    <div class="col-xs-12 col-sm-12 p-0">
      <img v-if="content.img" class="block-img"
        :src="`${getImageUrl(content.img)}`" alt="img">
    </div>
    <div v-if="button_valid && colBlock">
     <button
        type="button"
        class="btn emergo-green-button side-btn float-btn"
        @click="$emit('openRequest')"
      >
        <span>{{button_name}}</span>
      </button>
      </div>
      <div
        class="desc-subheader col-xs-12 col-sm-12 p-0"
        :class="[(content.bg_color!== undefined && content.bg_color=='white')?'text-color-blue':'',
        colBlock ? 'desc-subheader col-xs-12 col-sm-12 col-md-10 p-0': '']"
        v-html="content.header"
      ></div>
      <div class="col-xs-12 col-sm-12 p-0" :class="[colBlock? 'col-md-7': '']">
        <span v-html="content.description"></span>
      </div>
      <button
        v-if="button_valid && !colBlock"
        type="button"
        class="btn emergo-green-button side-btn"
        @click="$emit('openRequest')"
      >
        <span>{{button_name}}</span>
      </button>
    </div>
    <div v-if="design_type=='laptop'" class="p-0 desc-content" ref="laptopContent">
      <div class="desc-subheader text-color-blue" v-html="content.header"></div>
      <div v-html="content.description"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'content',
    'design_type',
    'alignment',
    'button_valid',
    'button_name',
    'colBlock',
    'sasToken',
  ],
  data() {
    return {};
  },
  mounted() {
    this.laptopHeight();
  },
  methods: {
    laptopHeight() {
      if (this.$refs.laptopContent) {
        const height = this.$refs.laptopContent.clientHeight;
        this.$emit('laptopblockheight', height);
      }
    },
    getImageUrl(filePath) {
      return `${process.env.VUE_APP_AZURE_BLOB_URL}/${filePath}?${this.sasToken}`;
    },
  },
};
</script>
<style scoped>
h3 {
  margin-top: 5px;
  margin-bottom: 15px;
}
.side-btn {
  border-radius: 25px;
  font-size: 25px;
  padding-left: 25px;
  padding-right: 25px;
  line-height: 35px;
  font-weight: 400;
}
.block-img {
  width: 500px;
  padding-bottom: 20px;
}
.p-0 {
  padding: 0px;
}
.p-35 {
  padding: 35px;
}
.pr-0 {
  padding-right: 0px;
}
.pos-rel {
  position: relative;
}
.bg-color-blue {
  background: #00518a;
}
.box-min-height {
  height: 100%;
  flex: 0 0 40%;
  margin: 0;
}
.text-color-white {
  color: #fff;
}
.desc-subheader {
  font-weight: 300;
  font-size: 26px;
  line-height: 33px;
  margin: 0 0 20px;
}
.desc-content p {
  font-weight: normal;
  font-size: 16px;
  line-height: 25px;
  color: rgba(0, 0, 0, 0.7);
}
.desc-content {
  font-size: 16px;
  font-weight: normal;
}
.text-color-blue {
  color: #00518a;
}
.float-btn {
  margin-bottom: 15px;
  position: absolute;
  right: 20px;
}
@media only screen and (min-width: 1024px) {
  .float-btn {
    float: right;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .block-img {
    width: 400px;
  }
}
@media only screen and (max-width: 767px) {
  .side-btn {
    font-size: 18px;
  }
  .box-min-height {
    padding: 20px;
  }
  ::v-deep .box-min-height ul {
    padding-inline-start: 20px;
  }
  .block-img {
    width: 280px;
  }
  .float-btn {
    margin-bottom: 15px;
    position: relative;
    margin-left: 20px;
  }
}
@media only screen and (max-width: 374px){
    .block-img {
    width: 225px;
  }
}
</style>
